import type { IconSvgObject } from './types';

const LeftAngleIcon: IconSvgObject = [
  ["path", { d: "M18 12H14C12.8954 12 12 12.8954 12 14V18", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 18.5H17.5C18.0523 18.5 18.5 18.0523 18.5 17.5V3M3 18.5L5.5 16M3 18.5L5.5 21M18.5 3L16 5.5M18.5 3L21 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LeftAngleIcon;
